import { FC } from 'react'
import { Button, Col, Row, Tag, Typography } from 'antd'
import { Storefront, PencilSimpleLine, Trash } from '@phosphor-icons/react'
import CardWrapper from './card-wrapper'
import TitleStop from './title-stop'
import { StepState } from '../../../domain/task'
const { Text } = Typography

export interface ItemStop {
  sku: string
  id: string
}
export interface CardStopProps {
  id: string
  title: string
  storeName: string
  items: ItemStop[]
  isOrigin: boolean
  bgColorTag?: string
  textColorTag?: string
  handleEdit?: (id: string) => void
  handleDelete?: (id: string) => void
  status: StepState
}

const CardStop: FC<CardStopProps> = ({
  id,
  title,
  storeName,
  items,
  isOrigin,
  bgColorTag,
  textColorTag,
  handleEdit,
  handleDelete,
  status
}) => {
  return (
    <CardWrapper>
      <Row gutter={[8, 8]}>
        <Col style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <TitleStop text={title} />
            <Tag
              icon={<Storefront />}
              color={bgColorTag || '#F3F5F9'}
              style={{
                display: 'flex',
                gap: '6px',
                alignItems: 'center',
                height: 'max-content',
                color: textColorTag || '#000'
              }}
            >
              <Text style={{ fontWeight: 700, fontSize: '12px' }}>{storeName}</Text>
            </Tag>
          </div>
          {!isOrigin && status === StepState.PENDING && (
            <div>
              {handleEdit && <Button onClick={() => handleEdit(id)} type='link' icon={<PencilSimpleLine />}></Button>}
              {handleDelete && <Button onClick={() => handleDelete(id)} type='text' icon={<Trash />}></Button>}
            </div>
          )}
        </Col>
        {items?.length > 0 && (
          <Col style={{ display: 'flex', gap: '8px' }}>
            <Text style={{ fontSize: '12px', color: '#00000073' }}>{`Items(${items.length}):`}</Text>
            <Text style={{ fontWeight: 500, fontSize: '12px' }}>{items.map((item) => item.sku).join(' ')}</Text>
          </Col>
        )}
      </Row>
    </CardWrapper>
  )
}

export default CardStop
